import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class OrderPaymentProcessService {

  constructor(
    private http: HttpClient
  ) { }

  createPaymentProcess(payment: any): Observable<any> {
    return this.http.post<any>(`/api/order-payment-process`, payment);
  }

  updatePaymentProcess(paymentId: string, data: any): Observable<any> {
    return this.http.put<any>(`/api/order-payment-process/${paymentId}`, data);
  }
  
  updatePaymentProcessbyPayment(paymentId: string, data: any): Observable<any> {
    return this.http.put<any>(`/api/order-payment-process-payment/${paymentId}`, data);
  }

}
///order-payment-processRoute::post('order-payment-process', [OrderPaymentProcessController::class, 'store']);
//         Route::put('order-payment-process/{id}', [OrderPaymentProcessController::class, 'update'])->whereNumber('id');
//         Route::patch('order-payment-process/{id}'
// {
//   "order_id": 42,
//   "status": "pending",
//   "amount": 1500,
//   "currency": "MXN"
// }